export class UserAssessment {
    UserAssessmentId: string;
    AssessmentId: Number;
    AssessmentName: string;
    UserAssessmentStatusId: number;
    TimeRemainingInMinutes: number;
    RunningScore: number;
    TotalScore?: number;
}